import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-054d9cba")

_pushScopeId("data-v-054d9cba")
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = { class: "paymentApp" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h4", null, "Pagar pelo app", -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "Pix", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "logoPix",
  src: "assets/logoPix.png"
}, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "info-card" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Adicionar cartão de crédito ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Adicionar cartão de crédito ")
const _hoisted_12 = {
  key: 2,
  class: "notPaymentApp"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "notPaymentAppContainer" }, [
  /*#__PURE__*/_createVNode("p", null, "Este estabelecimento não aceita pagamento online.")
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("h4", null, "Pagar na entrega", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_with_balance = _resolveComponent("header-with-balance")
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_list = _resolveComponent("ion-list")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_img = _resolveComponent("ion-img")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            "has-go-back-modal": true,
            title: "Formas de pagamento",
            "has-go-back": false
          }),
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.loadingRef)
                ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                    default: _withId(() => [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList(2, (i) => {
                        return _createVNode(_component_ion_card, { key: i }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_card_content, { class: "paymentMethod" }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_skeleton_text, { animated: "" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      }), 64))
                    ]),
                    _: 1
                  }))
                : (_ctx.isPaymentOnline || _ctx.isPix)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _createVNode(_component_ion_list, null, {
                        default: _withId(() => [
                          (_ctx.isPix)
                            ? (_openBlock(), _createBlock(_component_ion_card, { key: 0 }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_card_content, {
                                    class: "paymentMethod",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedOnlinePayment({ nickname: 'Pix', pix: true })))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_5,
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.isPaymentOnline)
                            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
                                  return (_openBlock(), _createBlock(_component_ion_card, {
                                    key: card.nickname,
                                    onClick: ($event: any) => (_ctx.selectedOnlinePayment(card))
                                  }, {
                                    default: _withId(() => [
                                      _createVNode(_component_ion_card_content, { class: "paymentMethod" }, {
                                        default: _withId(() => [
                                          _createVNode("div", _hoisted_8, [
                                            _createVNode("p", null, _toDisplayString(card.nickname), 1),
                                            _createVNode("i", null, "**** " + _toDisplayString(card.lastDigits), 1)
                                          ]),
                                          _createVNode("img", {
                                            class: "logoPix",
                                            src: `https://thelivery.com.br/static/assets/layout/card-flags/${card.type.toLowerCase()}.svg`
                                          }, null, 8, ["src"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      (_ctx.isPaymentOnline)
                        ? (_openBlock(), _createBlock("div", _hoisted_9, [
                            (_ctx.cards.length > 0)
                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 0,
                                  class: "addCard",
                                  fill: "clear",
                                  onClick: _ctx.addCard
                                }, {
                                  default: _withId(() => [
                                    _hoisted_10
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_ion_button, {
                                  key: 1,
                                  class: "addCard",
                                  onClick: _ctx.addCard
                                }, {
                                  default: _withId(() => [
                                    _hoisted_11
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_12, [
                      _hoisted_13
                    ]))
            ]),
            _createVNode("div", null, [
              _hoisted_14,
              (_ctx.loadingRef)
                ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                    default: _withId(() => [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (i) => {
                        return _createVNode(_component_ion_card, { key: i }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_card_content, { class: "paymentMethod" }, {
                              default: _withId(() => [
                                _createVNode(_component_ion_skeleton_text, { animated: "" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      }), 64))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paymentMethodsEstablishmentRef, (paymentMethod) => {
                        return (_openBlock(), _createBlock("div", {
                          key: paymentMethod.id
                        }, [
                          (paymentMethod.paymentMethod)
                            ? (_openBlock(), _createBlock(_component_ion_card, {
                                key: 0,
                                onClick: ($event: any) => (_ctx.selectPaymentMethod(paymentMethod))
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_card_content, { class: "paymentMethod" }, {
                                    default: _withId(() => [
                                      _createVNode("p", null, _toDisplayString(paymentMethod.paymentMethod.name), 1),
                                      _createVNode(_component_ion_img, {
                                        src: `https://thelivery.com.br/static/${paymentMethod.paymentMethod.logo}`
                                      }, null, 8, ["src"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})